<template>
  <div class="wrap">
    <headTop></headTop>
    <!-- 中间内容 -->
    <div class="specialistContent">
      <div style="padding:0.1em 3em">
        <div class="box">
          <div class="specialistContent_left">
            <div class="specialistContent_left_title">智能专科</div>
            <div
              v-for="(item,index) in leftMenu1"
              :key="index"
              :class="{active: toggle == item.name}"
              @click="changeDetail(item)"
            >{{item.name}}</div>
            <div class="specialistContent_left_title">两大中心</div>
            <div
              v-for="(item) in leftMenu2"
              :key="item.id"
              :class="{active: toggle == item.name}"
              @click="changeDetail(item)"
            >{{item.name}}</div>
          </div>
          <!-- 右侧内容 -->
          <div class="specialistContent_right">
            <div class="specialistContent_right_title">
              <div class="title">{{toggle}}</div>
            </div>
            <div class="serviceContent">
              <h4>科室成员</h4>
              <div class="serviceContent_item" v-for="item in getOfficeInfoByIdObj.enterpriseList" :key="item.id" @click="goToEnterpriseDetail(item.id)">
                <div class="serviceContent_item_left">
                  <img class="image" :src="$store.getters.imgUrl+item.logo" alt="">
                  <h6>{{item.name}}</h6>
                </div>
                <div class="serviceContent_item_right" v-html="item.introductionContent"></div>
              </div>
            </div>
            <div class="serviceContent">
              <h4>项目专员</h4>
              <div class="serviceContent_item" v-for="item in getOfficeInfoByIdObj.expertList" :key="item.id" @click="goToSavant(item.id)">
                <div class="serviceContent_item_left">
                  <div class="imageRound" :style="{'background-image': `url(${$store.getters.imgUrl+item.avatar})`}"></div>
                  <!-- <img class="imageRound" :src="$store.getters.imgUrl+item.avatar" alt=""> -->
                  <h6 class="name">{{item.name}}</h6>
                </div>
                <div class="serviceContent_item_right">
                  <h5>个人简介</h5>
                  <div v-html="item.introduceContent"></div>
                </div>
              </div>
            </div>
            <div class="serviceContent" v-if="getOfficeInfoByIdObj.office">
              <h4>服务内容</h4>
              <span class="content"   v-html="getOfficeInfoByIdObj.office.serviceContent"></span>
              <!-- <img :src="$store.getters.imgUrl+getOfficeInfoByIdObj.office.logo" alt=""> -->
            </div>
          </div>
        </div>
      </div>

      <div class="footer">
        <footCode></footCode>
      </div>
    </div>
  </div>
</template>
<script>
import footCode from "../../components/footCode";
import headTop from "../../components/HeadTop";
export default {
  name: "specialistCenter",
  components: {
    footCode,
    headTop,
  },
  data() {
    return {
      leftMenu1: [],
      leftMenu2: [],
      officeId: null,
      toggle: "",
      imgUrl: "",
      serviceContent: "", //服务内容
      serviceCompany: [],
      commissioner: [],
      getOfficeInfoByIdObj: {}, // 返回数据
    };
  },
  mounted() {
    this.toggle = this.$route.query.name;
    this.officeId = this.$route.query.id;
    this.getCenterList();
    this.getCenterListDetail();
  },
  methods: {
    idxActiveFun(_idx) {
      this.idxActive = _idx;
    },
    goToEnterpriseDetail(id){
       this.$router.push({
        path: "/enterprise/enterpriseDetail",
        query: {
          id,
        },
      });
    },
    goToSavant(id){
        this.$router.push({
        path: "/savant/detail",
        query: {
          id,
        },
      });
    },
    // 获取中心列表
    getCenterList() {
      this.ajaxUtil({
        method: "get",
        url: this.$store.state.axiosUrl + "/api/home/getAllOffice",
      }).then((res) => {
        this.leftMenu1 = res.data.filter((item) => {
          return item.type == 1;
        });
        this.leftMenu2 = res.data.filter((item) => {
          return item.type == 2;
        }).splice(0,2);
      });
    },
    //获取中心列表详情
    getCenterListDetail() {
      this.ajaxUtil({
        method: "get",
        url:
          this.$store.state.axiosUrl +
          `/api/home/getOfficeInfoById?officeId= ${this.officeId}`,
        // data:{officeId:this.officeId}
      }).then((res) => {
        console.log(res);
        this.getOfficeInfoByIdObj = res.data
        // this.serviceContent = res.data.office.serviceContent;
        // this.serviceCompany = res.data.enterpriseList;
        // this.commissioner = res.data.expertList;
      }); 
    },
    // 切换
    changeDetail(item) {
      this.toggle = item.name;
      this.officeId = item.id;
      this.getCenterListDetail();
    },
  },
};
</script>
<style scoped lang="less">
// @import url('~@/assets/css/index.less');
.wrap {
  display: flex;
  flex-direction: column;
  min-width: 12.8em;
  // box-sizing: border-box;
}
.specialistContent {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  // overflow: auto;
  // padding: 0.1em 3em;
  .specialistContent_left {
    font-size: 0.17em;
    color: #333;
    div {
      padding: 0.6em 1em;
      text-align: center;
      background-color: #d6f0f6;
      margin-top: 0.08em;
      cursor: pointer;
      font-size: 0.85em;
      width: 200px;
    }
    .specialistContent_left_title {
      background: radial-gradient(circle, #3cc9e4 0%, #2579bf 100%);
      color: #fff;
      padding: 0.6em;
      //   width: 15em;
      font-size: 1em;
    }
    .active {
      color: #2579bf;
      background-color: #fff;
      border-left: 0.5em solid #2579bf;
    }
  }
  .specialistContent_right {
    color: #333;
    margin-left: 2em;
    margin-top: 0.1em;
    font-size: 0.18em;
    flex: 1;
    .specialistContent_right_title {
      font-size: 0.2em;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 1em;
      border-bottom: 1px solid #e5e5e5;
      div {
        padding-bottom: 1em;
      }
      .title {
        color: #2579bf;
        font-size: 16px;
        padding-bottom: 5px;
        border-bottom: 4px solid #2579bf;
      }
    }
    .serviceContent {
      padding-top: 2em;
      padding-left: 0em;
      &_item{
        border-bottom: 1px solid #E5E5E5;
        padding: .3rem 0;
        display: flex;
        &_left{
          margin: 0 .2rem 0.0 0;
          .image{
            width: 2.4rem;
            // height: 1.3rem;
            margin: 0 0 .15rem;
            border: 1px solid #E5E5E5;
          }
          .imageRound{
            width: 1.36rem;
            height: 1.36rem;
            margin: 0 0 .15rem;
            border-radius: 100%;
            border: 1px solid #E5E5E5;
            background-size: cover;
          }
          h6{
            color: #2579BF;
            font-size: 0.9em;
            text-align: center;
            &.name{
              color: #666;
            }
          }
        }
        &_right{
          font-size: 0.9em;
          color: #333;
          h5{
            font-size: 1em;
            margin: 0 0 .4em;
          }
          /deep/p{
            text-indent: 30px;
            line-height: 22px;
          }
        }
      }
      h4 {
        margin-bottom: 0.5em;
        font-size: 0.9em;
      }
      .content {
        display: inline-block;
        text-indent: 40px;
        line-height: 1.5em;
        font-size: 0.9em;
      }
      span {
        font-size: 0.9em;
      }
      //头像
      .serviceContentList {
        display: flex;
        flex-direction: column;

        .serviceContentListItem {
          display: flex;
          // align-items: center;
          margin-top: 20px;
          .left {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-right: 30px;
          }
          .right {
            display: flex;
            flex-direction: column;
            span {
              text-indent: 30px;
              margin-top: 5px;
            }
          }
        }
        img {
          width: 4em;
          height: 4em;
          margin-bottom: 0.5em;
        }
      }
    }
    .serviceContent.target {
      span {
        margin-right: 20px;
      }
    }
    .imgBox {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 0em;
      img {
        height: 12em;
        width: 45em;
      }
    }
  }
}
.footer {
  width: 100%;
  margin-top: 0.2em;
}
.titlePosition {
  font-size: 0.15em;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  color: #666;
}
.box {
  display: flex;
}
.radioImg {
  width: 4em;
  height: 4em;
  margin-bottom: 0.5em;
  background-size: cover;
  border-radius: 50%;
}
.serviceContent_item{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/specialistCenter/index.vue